import Requester from '../../helpers/requester';
import { HTTP_METHODS } from '../../helpers/constants';
import { API_PATHS } from '../../helpers/endpoints';

export default {
  getProgressPaymentTemplates: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PROGRESS_PAYMENT_TEMPLATES}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteProgressPaymentTemplates: async (id, payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.PROGRESS_PAYMENT_TEMPLATES}/${id}?${payload}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addProgressPaymentTemplates: async (payload, type) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.PROGRESS_PAYMENT_TEMPLATES}${type ? `/${type}` : ''}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editProgressPaymentTemplates: async (payload, id, type) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.PROGRESS_PAYMENT_TEMPLATES}${type ? `/${type}` : ''}/${id}?force-update=false`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getClosedDates: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.CLOSED_DATES}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteClosedDates: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.CLOSED_DATES}/${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addClosedDate: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.CLOSED_DATES}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getProgressPaymentData: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PROGRESS_PAYMENTS}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getProgressPaymentDetail: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PROGRESS_PAYMENT_DETAILS}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getProgressPaymentOrderDetail: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PROGRESS_PAYMENT_ORDERS}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  exportProgressPaymentStatusReport: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.REPORT_EXPORT}/PROGRESS_PAYMENT_REPORT`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  refreshProgressPayment: async () => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.PROGRESS_PAYMENTS}?state=IN_PROGRESS`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getStoreProgressPaymentStatus: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORE_PROGRESS_PAYMENTS}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getStoreProgressPaymentDetail: async (id) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORE_PROGRESS_PAYMENTS}/${id}/detail`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCourierDeliveryEfficiencyOtifMonthly: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIER_DELIVERY_EFFICIENCY_OTIF_MONTHLY}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCourierDeliveryEfficiencyOtifDaily: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIER_DELIVERY_EFFICIENCY_OTIF_DAILY}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  exportStoreProgressPaymentStatusReport: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.REPORT_EXPORT}/store_progress_payment_report`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  approveInvoicePayment: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.INVOICE_APPROVAL_APPROVE}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getProgressPaymentTemplateByStore: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PROGRESS_PAYMENT_TEMPLATE_BY_STORE_SEARCH}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
